import {SC_Department} from "./enums/SC_Department";

export class SC_Permissions {
    /**
     * Input property name constants for fromAPI
     */
    static readonly inputKeys = {
        readInternalNotes: 'readInternalNotes',
        writeInternalNotes: 'writeInternalNotes',
        readExternalNotes: 'readExternalNotes',
        writeExternalNotes: 'writeExternalNotes',
        viewLocations: 'viewLocations',
        writeLocations: 'writeLocations',
        writeCrews: 'writeCrews',
        viewReports: 'viewReports',
        writeReports: 'writeReports',
        viewReminders: 'viewReminders',
        writeReminders: 'writeReminders',
        viewSubs: 'viewSubs',
        writeSubs: 'writeSubs',
        viewBasicPayroll: 'viewBasicPayroll',
        writeBasicPayroll: 'writeBasicPayroll',
        viewAdvancedPayroll: 'viewAdvancedPayroll',
        writeAdvancedPayroll: 'writeAdvancedPayroll',
        viewEmployeeReports: 'viewEmployeeReports',
        writeEmployeeReports: 'writeEmployeeReports',
        viewBudgetMonies: 'viewBudgetMonies',
        writeBudgetMonies: 'writeBudgetMonies',
        viewBudget: 'viewBudget',
        writeBudget: 'writeBudget',
        readWorkorderImages: 'readWorkorderImages',
        writeWorkorderImages: 'writeWorkorderImages',
        scheduleService: 'scheduleService',
        seeNonOwnedData: 'seeNonOwnedData',
        seeCoOwnedData: 'seeCoOwnedData',
        performCheckin: 'performCheckin',
        editService: 'editService',
        roles: 'roles',
    };

    constructor({
        readInternalNotes = false,
        writeInternalNotes = false,
        readExternalNotes = false,
        writeExternalNotes = false,
        viewLocations = false,
        writeLocations = false,
        writeCrews = false,
        viewReports = false,
        writeReports = false,
        viewReminders = false,
        writeReminders = false,
        viewSubs = false,
        writeSubs = false,
        viewBasicPayroll = false,
        writeBasicPayroll = false,
        viewAdvancedPayroll = false,
        writeAdvancedPayroll = false,
        viewEmployeeReports = false,
        writeEmployeeReports = false,
        viewBudgetMonies = false,
        writeBudgetMonies = false,
        viewBudget = false,
        writeBudget = false,
        readWorkorderImages = false,
        writeWorkorderImages = false,
        scheduleService = false,
        seeNonOwnedData = false,
        seeCoOwnedData = false,
        performCheckin = false,
        editService = false,
        departments = [],
    } = {}) {
        this.readInternalNotes = readInternalNotes;
        this.writeInternalNotes = writeInternalNotes;
        this.readExternalNotes = readExternalNotes;
        this.writeExternalNotes = writeExternalNotes;
        this.viewLocations = viewLocations;
        this.writeLocations = writeLocations;
        this.writeCrews = writeCrews;
        this.viewReports = viewReports;
        this.writeReports = writeReports;
        this.viewReminders = viewReminders;
        this.writeReminders = writeReminders;
        this.viewSubs = viewSubs;
        this.writeSubs = writeSubs;
        this.viewBasicPayroll = viewBasicPayroll;
        this.writeBasicPayroll = writeBasicPayroll;
        this.viewAdvancedPayroll = viewAdvancedPayroll;
        this.writeAdvancedPayroll = writeAdvancedPayroll;
        this.viewEmployeeReports = viewEmployeeReports;
        this.writeEmployeeReports = writeEmployeeReports;
        this.viewBudgetMonies = viewBudgetMonies;
        this.writeBudgetMonies = writeBudgetMonies;
        this.viewBudget = viewBudget;
        this.writeBudget = writeBudget;
        this.readWorkorderImages = readWorkorderImages;
        this.writeWorkorderImages = writeWorkorderImages;
        this.scheduleService = scheduleService;
        this.seeNonOwnedData = seeNonOwnedData;
        this.seeCoOwnedData = seeCoOwnedData;
        this.performCheckin = performCheckin;
        this.editService = editService;
        this.departments = departments;
    }

    readInternalNotes: boolean;
    writeInternalNotes: boolean;
    readExternalNotes: boolean;
    writeExternalNotes: boolean;
    viewLocations: boolean;
    writeLocations: boolean;
    writeCrews: boolean;
    viewReports: boolean;
    writeReports: boolean;
    viewReminders: boolean;
    writeReminders: boolean;
    viewSubs: boolean;
    writeSubs: boolean;
    viewBasicPayroll: boolean;
    writeBasicPayroll: boolean;
    viewAdvancedPayroll: boolean;
    writeAdvancedPayroll: boolean;
    viewEmployeeReports: boolean;
    writeEmployeeReports: boolean;
    viewBudgetMonies: boolean;
    writeBudgetMonies: boolean;
    viewBudget: boolean;
    writeBudget: boolean;
    readWorkorderImages: boolean;
    writeWorkorderImages: boolean;
    scheduleService: boolean;
    seeNonOwnedData: boolean;
    seeCoOwnedData: boolean;
    performCheckin: boolean;
    editService: boolean;
    departments: SC_Department[];

    static fromAPI(jsonin: Record<string, any>): SC_Permissions {
        return new SC_Permissions({
            readInternalNotes: (jsonin[SC_Permissions.inputKeys.readInternalNotes] ?? false),
            writeInternalNotes: jsonin[SC_Permissions.inputKeys.writeInternalNotes] ?? false,
            readExternalNotes: jsonin[SC_Permissions.inputKeys.readExternalNotes] ?? false,
            writeExternalNotes: jsonin[SC_Permissions.inputKeys.writeExternalNotes] ?? false,
            viewLocations: jsonin[SC_Permissions.inputKeys.viewLocations] ?? false,
            writeLocations: jsonin[SC_Permissions.inputKeys.writeLocations] ?? false,
            writeCrews: jsonin[SC_Permissions.inputKeys.writeCrews] ?? false,
            viewReports: jsonin[SC_Permissions.inputKeys.viewReports] ?? false,
            writeReports: jsonin[SC_Permissions.inputKeys.writeReports] ?? false,
            viewReminders: jsonin[SC_Permissions.inputKeys.viewReminders] ?? false,
            writeReminders: jsonin[SC_Permissions.inputKeys.writeReminders] ?? false,
            viewSubs: jsonin[SC_Permissions.inputKeys.viewSubs] ?? false,
            writeSubs: jsonin[SC_Permissions.inputKeys.writeSubs] ?? false,
            viewBasicPayroll: jsonin[SC_Permissions.inputKeys.viewBasicPayroll] ?? false,
            writeBasicPayroll: jsonin[SC_Permissions.inputKeys.writeBasicPayroll] ?? false,
            viewAdvancedPayroll: jsonin[SC_Permissions.inputKeys.viewAdvancedPayroll] ?? false,
            writeAdvancedPayroll: jsonin[SC_Permissions.inputKeys.writeAdvancedPayroll] ?? false,
            viewEmployeeReports: jsonin[SC_Permissions.inputKeys.viewEmployeeReports] ?? false,
            writeEmployeeReports: jsonin[SC_Permissions.inputKeys.writeEmployeeReports] ?? false,
            viewBudgetMonies: jsonin[SC_Permissions.inputKeys.viewBudgetMonies] ?? false,
            writeBudgetMonies: jsonin[SC_Permissions.inputKeys.writeBudgetMonies] ?? false,
            viewBudget: jsonin[SC_Permissions.inputKeys.viewBudget] ?? false,
            writeBudget: jsonin[SC_Permissions.inputKeys.writeBudget] ?? false,
            readWorkorderImages: jsonin[SC_Permissions.inputKeys.readWorkorderImages] ?? false,
            writeWorkorderImages: jsonin[SC_Permissions.inputKeys.writeWorkorderImages] ?? false,
            scheduleService: jsonin[SC_Permissions.inputKeys.scheduleService] ?? false,
            seeNonOwnedData: jsonin[SC_Permissions.inputKeys.seeNonOwnedData] ?? false,
            seeCoOwnedData: jsonin[SC_Permissions.inputKeys.seeCoOwnedData] ?? false,
            performCheckin: jsonin[SC_Permissions.inputKeys.performCheckin] ?? false,
            editService: jsonin[SC_Permissions.inputKeys.editService] ?? false,
            departments: jsonin[SC_Permissions.inputKeys.roles]?.length ? jsonin[SC_Permissions.inputKeys.roles].map(it => SC_Department.fromAPIString(it)).filter(Boolean) : false,
        });
    }

    /**
     * Creates a deep clone of this SC_Permissions instance.
     * @returns A new SC_Permissions instance with the same values.
     */
    clone(): SC_Permissions {
        const cloned = new SC_Permissions();

        cloned.readInternalNotes = this.readInternalNotes;
        cloned.writeInternalNotes = this.writeInternalNotes;
        cloned.readExternalNotes = this.readExternalNotes;
        cloned.writeExternalNotes = this.writeExternalNotes;
        cloned.viewLocations = this.viewLocations;
        cloned.writeLocations = this.writeLocations;
        cloned.writeCrews = this.writeCrews;
        cloned.viewReports = this.viewReports;
        cloned.writeReports = this.writeReports;
        cloned.viewReminders = this.viewReminders;
        cloned.writeReminders = this.writeReminders;
        cloned.viewSubs = this.viewSubs;
        cloned.writeSubs = this.writeSubs;
        cloned.viewBasicPayroll = this.viewBasicPayroll;
        cloned.writeBasicPayroll = this.writeBasicPayroll;
        cloned.viewAdvancedPayroll = this.viewAdvancedPayroll;
        cloned.writeAdvancedPayroll = this.writeAdvancedPayroll;
        cloned.viewEmployeeReports = this.viewEmployeeReports;
        cloned.writeEmployeeReports = this.writeEmployeeReports;
        cloned.viewBudgetMonies = this.viewBudgetMonies;
        cloned.writeBudgetMonies = this.writeBudgetMonies;
        cloned.viewBudget = this.viewBudget;
        cloned.writeBudget = this.writeBudget;
        cloned.readWorkorderImages = this.readWorkorderImages;
        cloned.writeWorkorderImages = this.writeWorkorderImages;
        cloned.scheduleService = this.scheduleService;
        cloned.seeNonOwnedData = this.seeNonOwnedData;
        cloned.seeCoOwnedData = this.seeCoOwnedData;
        cloned.performCheckin = this.performCheckin;
        cloned.editService = this.editService;
        cloned.departments = this.departments.slice();

        return cloned;
    }

    get atLeastCoOwn() {
        return this.seeNonOwnedData || this.seeCoOwnedData;
    }
}
